import script from "./TestChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TestChart.vue?vue&type=script&setup=true&lang=js"

import "./TestChart.vue?vue&type=style&index=0&id=75d64056&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d64056"]])

export default __exports__